import { z } from 'zod';

// ============================================
// 生成追溯元数据（公共）
// ============================================

export const GenerationMetaSchema = z.object({
  seed: z.string().optional(),
  provider: z.string().optional(),
  model: z.string().optional(),
  promptVersion: z.string().optional(),
  schemaVersion: z.string().default('1.0.0'),
  createdAt: z.number().default(() => Date.now()),
});

export type GenerationMeta = z.infer<typeof GenerationMetaSchema>;
